<template>
  <v-dialog v-model="transferMoneyDialog" width="700" @keydown.esc="closeDialog" @click:outside="closeDialog">
    <v-card class="transfer-money">
      <div class="tw-text-right tw-pr-4 tw-pt-3">
        <v-icon @click="closeDialog" color="red">mdi-close</v-icon>
      </div>
      <v-card-title class="text-h6 d-flex justify-center"> Transfer Money to Player </v-card-title>
      <v-col>
        <v-tabs
          active-class="transfer  "
          background-color="transparent"
          v-model="transfermoneytab"
          slider-color="#45d0d2bf"
          slider-size="5"
        >
          <v-row class="d-flex justify-space-around">
            <v-tab class="" href="#deposit"><h6 class="tabs-text white--text">Deposit</h6></v-tab>
            <v-tab class="" href="#cashout"><h6 class="tabs-text white--text">Cashout</h6></v-tab>
          </v-row>
        </v-tabs>
      </v-col>
      <v-tabs-items class="tabs-items" v-model="transfermoneytab">
        <v-tab-item :value="transfermoneytab">
          <Deposit
            v-if="transfermoneytab == 'deposit'"
            :key="`deposit-${componentKey}`"
            :transferMoneyDialog="transferMoneyDialog"
            :activeTab="transfermoneytab"
            @closeDialog="closeDialog"
          />
          <Cashout
            v-if="transfermoneytab == 'cashout'"
            :key="`cashout-${componentKey}`"
            :transferMoneyDialog="transferMoneyDialog"
            :activeTab="transfermoneytab"
            @closeDialog="closeDialog"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>
<script>
import Cashout from "./transfermoney/Cashout.vue";
import Deposit from "./transfermoney/Deposit.vue";
export default {
  props: {
    transferMoneyDialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      transfermoneytab: "deposit",
      componentKey: 0,
    };
  },
  components: {
    Cashout,
    Deposit,
  },
  watch: {
    transferMoneyDialog(newVal) {
      // Reset tab to deposit and increment key to force component refresh when modal opens
      if (newVal) {
        this.transfermoneytab = "deposit";
        this.componentKey += 1; // Increment key to force fresh component instances
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog", false);
      this.transfermoneytab = "deposit";
    },
  },
};
</script>
<style scoped>
.transfer-money {
  background: #262626 !important;
  border-radius: 20px !important;
}
.transfer {
  justify-content: space-around !important;
}
</style>
